import { initSignature } from "./jsSignature";
import dayjs = require("dayjs");
/*--------------------------------------------------------------------------
*  Create Listing - Change the pre-select option's text to "請選擇"
* -------------------------------------------------------------------------*/
export function handleCreateListingCustomFieldSelectText() {
    let form = document.querySelector("#submit_property_form") as HTMLFormElement;
    if (form){
        let allSelect = form.querySelectorAll("select");
        allSelect.forEach((select) => {
            let allOptions = select.querySelectorAll("option");
    
            allOptions[0].innerText = "請選擇";
        });
    }
}

/*--------------------------------------------------------------------------
*  Create Listing - Validation effect on custom field
* -------------------------------------------------------------------------*/
export function handleCreateListingCustomFieldValidation() {
    let form = document.querySelector("#submit_property_form") as HTMLFormElement;
	if (form){
		jQuery("select").on("changed.bs.select", 
		function(e, clickedIndex, newValue, oldValue) {
			let hasValue = (this as HTMLSelectElement).value == "請選擇";
			
			if (hasValue)
				this.parentElement.classList.add("is-invalid");
			else
				this.parentElement.classList.remove("is-invalid");

		});
	}
}

/*--------------------------------------------------------------------------
*  Create Listing - Translate Detail section's small tag from "only digits" to "只輸入數字"
* -------------------------------------------------------------------------*/
export function handleCreateListingOnlyDigitsText() {
    let digitsTags = document.querySelectorAll("#details small");
    if (digitsTags){
        digitsTags.forEach((digitsTag) => {
            (digitsTag as HTMLElement).innerText = "只輸入數字";
        });
    }
}

/*--------------------------------------------------------------------------
*  Create Listing - display the information on the contract preview page
* -------------------------------------------------------------------------*/
export function handleCreateListingContractPreview() {
    // // Library for converting number to chinese words
    // var converter = require("number-to-chinese-words");
    // converter.default.labels = Object.assign({},converter.default.labels, {
    //     digits : ['零','壹', '貳', '參', '肆', '伍', '陸', '柒', '捌', '玖'],
    //     units: ['','拾', '佰', '仟', '萬', '拾', '佰', '仟', '億', '拾', '佰', '仟', '兆', '拾', '佰', '仟', '京', '拾', '佰', '仟', '垓']
    // })

    const form = document.querySelector("#submit_property_form") as HTMLFormElement;
    if (form) {
        // Set the visit date not before today
        const rentStartDate = document.querySelector('#submit_property_form input[name="rent_start_date"]') as HTMLInputElement;
        jQuery(rentStartDate).datepicker('setStartDate', dayjs().format('YYYY-MM-DD'));
        
        // //Date
        // let dateStart = new Date;
        // let dateEnd = new Date(dateStart.getTime() + (90 * 24 * 60 * 60 * 1000));
        // let signDate = `${dateStart.getDate()} - ${dateStart.getMonth() + 1} - ${dateStart.getFullYear()}`;

        // //Input field
        // const createListingPropTitle = form.querySelector('#prop_title') as HTMLInputElement;
        // const createListingPropPrice = form.querySelector('#prop_price') as HTMLInputElement;
        // const createListingManagementFee = form.querySelector('select[name="e5b7aee9a489e58f8ae7aea1e79086e8b2bb[]"]') as HTMLSelectElement;
        // const createListingInspectApprove = form.querySelectorAll('input[name="create_listing_inspect_approve"]') as NodeList;
        // const createListingInspectA = form.querySelectorAll('input[name="create_listing_inspect_a"]') as NodeList;
        // const createListingInspectB = form.querySelectorAll('input[name="create_listing_inspect_b"]') as NodeList;
        // const createListingInspectC = form.querySelectorAll('input[name="create_listing_inspect_c"]') as NodeList;
        // const createListingSellA = form.querySelectorAll('input[name="create_listing_sell_a"]') as NodeList;
        // const createListingAdvertiseA = form.querySelectorAll('input[name="create_listing_advertise_a"]') as NodeList;
        // const createListingAdditionalTerm = form.querySelector('#create_listing_additional_term') as HTMLInputElement;
        // const createListingHKID = form.querySelector('#create_listing_hk_id') as HTMLInputElement;
        // const createListingSignatoryName = form.querySelector('#create_listing_signatory_name') as HTMLInputElement;
        // const createListingSignatoryPosition = form.querySelector('#create_listing_signatory_position') as HTMLInputElement;
        // const createListingBusinessRegistrationNumber = form.querySelector('#create_listing_business_registration_number') as HTMLInputElement;
        // const createListingLandlordAddress = form.querySelector('#create_listing_landlord_address') as HTMLInputElement;
        // const createListingLandlordPhone = form.querySelector('#create_listing_landlord_phone') as HTMLInputElement;
        // const createListingLandlordFax = form.querySelector('#create_listing_landlord_fax') as HTMLInputElement;
        
        // const createListingPropertyDisclaimer = form.querySelector('#property_disclaimer') as HTMLTextAreaElement;
        // const createListingInfoForm = form.querySelectorAll('input[name="createListingInfoForm"]') as NodeList;

        // const clearSignatureBtn = form.querySelector('#clearSignatureBtn') as HTMLElement;
        // const createListingSignature = form.querySelector('input[name="create_listing_signature"]') as HTMLInputElement;

        // const createListingPropPriceChinese = form.querySelector('#createListingAmountChinese') as HTMLInputElement;
        
        
        // //Contract elements
        // const createListingPropTitlePDF = form.querySelector('#createListingPropTitlePDF') as HTMLInputElement;
        // const createListingYearStartPDF = form.querySelector('#createListingYearStartPDF') as HTMLInputElement;
        // const createListingMonthStartPDF = form.querySelector('#createListingMonthStartPDF') as HTMLInputElement;
        // const createListingDateStartPDF = form.querySelector('#createListingDateStartPDF') as HTMLInputElement;
        // const createListingYearEndPDF = form.querySelector('#createListingYearEndPDF') as HTMLInputElement;
        // const createListingMonthEndPDF = form.querySelector('#createListingMonthEndPDF') as HTMLInputElement;
        // const createListingDateEndPDF = form.querySelector('#createListingDateEndPDF') as HTMLInputElement;
        // const createListingAmountChinesePDF = form.querySelector('#createListingAmountChinesePDF') as HTMLInputElement;
        // const createListingAmountPDF = form.querySelector('#createListingAmountPDF') as HTMLInputElement;
        // const createListingAmountRadioInclude = form.querySelector('#createListingAmountRadioInclude') as HTMLInputElement;
        // const createListingAmountRadioIncludeText = form.querySelector('#createListingAmountRadioIncludeText') as HTMLElement;
        // const createListingAmountRadioNotInclude = form.querySelector('#createListingAmountRadioNotInclude') as HTMLInputElement;
        // const createListingAmountRadioNotIncludeText = form.querySelector('#createListingAmountRadioNotIncludeText') as HTMLElement;
        // const createListingInspectApprovePDFAgent = form.querySelector('#createListingInspectApprovePDFAgent') as HTMLInputElement;
        // const createListingInspectApprovePDFTenant = form.querySelector('#createListingInspectApprovePDFTenant') as HTMLInputElement;
        // const createListingInspectAYes = form.querySelector('#createListingInspectAYes') as HTMLInputElement;
        // const createListingInspectANo = form.querySelector('#createListingInspectANo') as HTMLInputElement;
        // const createListingInspectBYes = form.querySelector('#createListingInspectBYes') as HTMLInputElement;
        // const createListingInspectBNo = form.querySelector('#createListingInspectBNo') as HTMLInputElement;
        // const createListingInspectCYes = form.querySelector('#createListingInspectCYes') as HTMLInputElement;
        // const createListingInspectCNo = form.querySelector('#createListingInspectCNo') as HTMLInputElement;
        // const createListingSellAYes = form.querySelector('#createListingSellAYes') as HTMLInputElement;
        // const createListingSellANo = form.querySelector('#createListingSellANo') as HTMLInputElement;
        // const createListingAdvertiseAYes = form.querySelector('#createListingAdvertiseAYes') as HTMLInputElement;
        // const createListingAdvertiseANo = form.querySelector('#createListingAdvertiseANo') as HTMLInputElement;
        // const createListingAdditionalTermPDF = form.querySelector('#createListingAdditionalTermPDF') as HTMLElement;
        // const createListingPropertyDisclaimerPDF = form.querySelector('#createListingPropertyDisclaimerPDF') as HTMLElement;
        // const createListingInfoForm1PDF = form.querySelector('#createListingInfoForm1PDF') as HTMLInputElement;
        // const createListingInfoForm2PDF = form.querySelector('#createListingInfoForm2PDF') as HTMLInputElement;
        // const createListingSignDatePDF1 = form.querySelector('#createListingSignDatePDF1') as HTMLElement;
        // const createListingSignDatePDF2 = form.querySelector('#createListingSignDatePDF2') as HTMLElement;
        // const createListingLandlordIdCardPDF = form.querySelector('#createListingLandlordIdCardPDF') as HTMLElement;
        // const createListingSignatoryNamePDF = form.querySelector('#createListingSignatoryNamePDF') as HTMLElement;
        // const createListingSignatoryProfessionPDF = form.querySelector('#createListingSignatoryProfessionPDF') as HTMLElement;
        // const createListingBusinessRegistrationNumberPDF = form.querySelector('#createListingBusinessRegistrationNumberPDF') as HTMLElement;
        // const createListingLandlordAddressPDF = form.querySelector('#createListingLandlordAddressPDF') as HTMLElement;
        // const createListingPhonePDF = form.querySelector('#createListingPhonePDF') as HTMLElement;
        // const scheduleLandlordFaxPDF = form.querySelector('#scheduleLandlordFaxPDF') as HTMLElement;
        // const createListingSignaturePDF = form.querySelector('#createListingSignaturePDF') as HTMLElement;
        

        // //Display information on contract elements
        // const createListingContract = document.querySelector('#create-listing-contract') as HTMLElement;
        // if (createListingContract) {
        //     createListingPropTitle.addEventListener('keyup', e => {
        //         e.preventDefault();
        //         createListingPropTitlePDF.innerText = createListingPropTitle.value;
        //     })
        //     createListingYearStartPDF.innerText = String(dateStart.getFullYear());
        //     createListingMonthStartPDF.innerText = String(dateStart.getMonth() + 1);
        //     createListingDateStartPDF.innerText = String(dateStart.getDate());
        //     createListingYearEndPDF.innerText = String(dateEnd.getFullYear());
        //     createListingMonthEndPDF.innerText = String(dateEnd.getMonth() + 1);
        //     createListingDateEndPDF.innerText = String(dateEnd.getDate());
        //     createListingSignDatePDF1.innerText = signDate;
        //     createListingSignDatePDF2.innerText = signDate;
            
        //     createListingPropPrice.addEventListener('keyup', e => {
        //         e.preventDefault();
        //         let amount = createListingPropPrice.value;
        //         createListingAmountChinesePDF.innerText = converter.toWords(amount);
        //         createListingAmountPDF.innerText = amount;
        //         createListingPropPriceChinese.value = converter.toWords(amount);
        //     })
        //     createListingManagementFee.addEventListener('change', e=> {
        //         e.preventDefault();
        //         if (createListingManagementFee.value == "包括") {
        //             createListingAmountRadioInclude.disabled = false;
        //             createListingAmountRadioInclude.checked = true;
        //             createListingAmountRadioIncludeText.innerHTML = "包括";
        //             createListingAmountRadioNotInclude.disabled = true;
        //             createListingAmountRadioNotInclude.checked = false;
        //             createListingAmountRadioNotIncludeText.innerHTML = "<strike>不包括</strike>";
        //         } else if (createListingManagementFee.value == "不包括"){
        //             createListingAmountRadioInclude.disabled = true;
        //             createListingAmountRadioInclude.checked = false;
        //             createListingAmountRadioIncludeText.innerHTML = "<strike>包括</strike>";
        //             createListingAmountRadioNotInclude.disabled = false;
        //             createListingAmountRadioNotInclude.checked = true;
        //             createListingAmountRadioNotIncludeText.innerHTML = "不包括";
        //         } else {
        //             createListingAmountRadioInclude.disabled = true;
        //             createListingAmountRadioInclude.checked = false;
        //             createListingAmountRadioIncludeText.innerHTML = "包括";
        //             createListingAmountRadioNotInclude.disabled = true;
        //             createListingAmountRadioNotInclude.checked = false;
        //             createListingAmountRadioNotIncludeText.innerHTML = "不包括";
        //         }
        //     })
            // createListingInspectApprove.forEach(createListingInspectApproveItem => createListingInspectApproveItem.addEventListener('change', e=> {
            //     e.preventDefault();
            //     if ((createListingInspectApprove[0] as HTMLInputElement).checked == true && (createListingInspectApprove[0] as HTMLInputElement).value == 'agent') {
            //         createListingInspectApprovePDFAgent.disabled = false;
            //         createListingInspectApprovePDFAgent.checked = true;
            //         createListingInspectApprovePDFAgent.innerHTML = "代理";
            //         createListingInspectApprovePDFTenant.disabled = true;
            //         createListingInspectApprovePDFTenant.checked = false;
            //         createListingInspectApprovePDFTenant.innerHTML = "<strike>租客</strike>";
            //     } else if ((createListingInspectApprove[1] as HTMLInputElement).checked == true && (createListingInspectApprove[1] as HTMLInputElement).value == 'tenant') {
            //         createListingInspectApprovePDFAgent.disabled = true;
            //         createListingInspectApprovePDFAgent.checked = false;
            //         createListingInspectApprovePDFAgent.innerHTML = "<strike>代理</strike>";
            //         createListingInspectApprovePDFTenant.disabled = false;
            //         createListingInspectApprovePDFTenant.checked = true;
            //         createListingInspectApprovePDFTenant.innerHTML = "租客";
            //     }
            // }))
            // createListingInspectA.forEach(createListingInspectAItem => createListingInspectAItem.addEventListener('change', e=> {
            //     e.preventDefault();
            //     if ((createListingInspectA[0] as HTMLInputElement).checked == true && (createListingInspectA[0] as HTMLInputElement).value == '1') {
            //         createListingInspectAYes.disabled = false;
            //         createListingInspectAYes.checked = true;
            //         createListingInspectANo.disabled = true;
            //         createListingInspectANo.checked = false;
            //     } else if ((createListingInspectA[1] as HTMLInputElement).checked == true && (createListingInspectA[1] as HTMLInputElement).value == '0') {
            //         createListingInspectAYes.disabled = true;
            //         createListingInspectAYes.checked = false;
            //         createListingInspectANo.disabled = false;
            //         createListingInspectANo.checked = true;
            //     }
            // }))
            // createListingInspectB.forEach(createListingInspectBItem => createListingInspectBItem.addEventListener('change', e=> {
            //     e.preventDefault();
            //     if ((createListingInspectB[0] as HTMLInputElement).checked == true && (createListingInspectB[0] as HTMLInputElement).value == '1') {
            //         createListingInspectBYes.disabled = false;
            //         createListingInspectBYes.checked = true;
            //         createListingInspectBNo.disabled = true;
            //         createListingInspectBNo.checked = false;
            //     } else if ((createListingInspectB[1] as HTMLInputElement).checked == true && (createListingInspectB[1] as HTMLInputElement).value == '0') {
            //         createListingInspectBYes.disabled = true;
            //         createListingInspectBYes.checked = false;
            //         createListingInspectBNo.disabled = false;
            //         createListingInspectBNo.checked = true;
            //     }
            // }))
            // createListingInspectC.forEach(createListingInspectCItem => createListingInspectCItem.addEventListener('change', e=> {
            //     e.preventDefault();
            //     if ((createListingInspectC[0] as HTMLInputElement).checked == true && (createListingInspectC[0] as HTMLInputElement).value == '1') {
            //         createListingInspectCYes.disabled = false;
            //         createListingInspectCYes.checked = true;
            //         createListingInspectCNo.disabled = true;
            //         createListingInspectCNo.checked = false;
            //     } else if ((createListingInspectC[1] as HTMLInputElement).checked == true && (createListingInspectC[1] as HTMLInputElement).value == '0') {
            //         createListingInspectCYes.disabled = true;
            //         createListingInspectCYes.checked = false;
            //         createListingInspectCNo.disabled = false;
            //         createListingInspectCNo.checked = true;
            //     }
            // }))
            // createListingSellA.forEach(createListingSellAItem => createListingSellAItem.addEventListener('change', e=> {
            //     e.preventDefault();
            //     if ((createListingSellA[0] as HTMLInputElement).checked == true && (createListingSellA[0] as HTMLInputElement).value == '1') {
            //         createListingSellAYes.disabled = false;
            //         createListingSellAYes.checked = true;
            //         createListingSellANo.disabled = true;
            //         createListingSellANo.checked = false;
            //     } else if ((createListingSellA[1] as HTMLInputElement).checked == true && (createListingSellA[1] as HTMLInputElement).value == '0') {
            //         createListingSellAYes.disabled = true;
            //         createListingSellAYes.checked = false;
            //         createListingSellANo.disabled = false;
            //         createListingSellANo.checked = true;
            //     }
            // }))
            // createListingAdvertiseA.forEach(createListingAdvertiseAItem => createListingAdvertiseAItem.addEventListener('change', e=> {
            //     e.preventDefault();
            //     if ((createListingAdvertiseA[0] as HTMLInputElement).checked == true && (createListingAdvertiseA[0] as HTMLInputElement).value == '1') {
            //         createListingAdvertiseAYes.disabled = false;
            //         createListingAdvertiseAYes.checked = true;
            //         createListingAdvertiseANo.disabled = true;
            //         createListingAdvertiseANo.checked = false;
            //     } else if ((createListingAdvertiseA[1] as HTMLInputElement).checked == true && (createListingAdvertiseA[1] as HTMLInputElement).value == '0') {
            //         createListingAdvertiseAYes.disabled = true;
            //         createListingAdvertiseAYes.checked = false;
            //         createListingAdvertiseANo.disabled = false;
            //         createListingAdvertiseANo.checked = true;
            //     }
            // }))
            // createListingAdditionalTerm.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     if (createListingAdditionalTerm.value == '') {
            //         createListingAdditionalTermPDF.classList.add('emptyField');
            //         createListingAdditionalTermPDF.innerText = '';
            //     } else {
            //         createListingAdditionalTermPDF.classList.remove('emptyField');
            //         createListingAdditionalTermPDF.innerText = createListingAdditionalTerm.value;
            //     }
            // })
            // createListingPropertyDisclaimer.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     if (createListingPropertyDisclaimer.value == '') {
            //         createListingPropertyDisclaimerPDF.innerHTML = '<u><p class="emptyField"></p></u><u><p class="emptyField"></p></u><u><p class="emptyField"></p></u><u><p class="emptyField"></p></u>';
            //     } else {
            //         createListingPropertyDisclaimerPDF.innerText = createListingPropertyDisclaimer.value;
            //     }
            // })
            // createListingInfoForm.forEach(createListingInfoFormItem => createListingInfoFormItem.addEventListener('change', e=> {
            //     e.preventDefault();
            //     if ((createListingInfoFormItem as HTMLInputElement).checked == true && (createListingInfoFormItem as HTMLInputElement).value == '1') {
            //         createListingInfoForm1PDF.disabled = false;
            //         createListingInfoForm1PDF.checked = true;
            //         createListingInfoForm2PDF.disabled = true;
            //         createListingInfoForm2PDF.checked = false;
            //     } else if ((createListingInfoFormItem as HTMLInputElement).checked == true && (createListingInfoFormItem as HTMLInputElement).value == '2') {
            //         createListingInfoForm1PDF.disabled = true;
            //         createListingInfoForm1PDF.checked = false;
            //         createListingInfoForm2PDF.disabled = false;
            //         createListingInfoForm2PDF.checked = true;
            //     }
            // }))
            // createListingHKID.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     createListingLandlordIdCardPDF.innerText = createListingHKID.value;
            // })
            // createListingSignatoryName.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     createListingSignatoryNamePDF.innerText = createListingSignatoryName.value;
            // })
            // createListingSignatoryPosition.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     createListingSignatoryProfessionPDF.innerText = createListingSignatoryPosition.value;
            // })
            // createListingBusinessRegistrationNumber.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     createListingBusinessRegistrationNumberPDF.innerText = createListingBusinessRegistrationNumber.value;
            // })
            // createListingLandlordAddress.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     createListingLandlordAddressPDF.innerText = createListingLandlordAddress.value;
            // })
            // createListingLandlordPhone.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     createListingPhonePDF.innerText = createListingLandlordPhone.value;
            // })
            // createListingLandlordFax.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     scheduleLandlordFaxPDF.innerText = createListingLandlordFax.value;
            // })
            // clearSignatureBtn.addEventListener('click', e => {
            //     // Clear the signature
            //     e.preventDefault();
            //     createListingSignaturePDF.innerHTML = "";
            //     (jQuery('.js-signature') as any).jqSignature('clearCanvas');
            //     let dataUrl = (jQuery('.js-signature') as any).jqSignature('getDataURL');
            //     createListingSignature.setAttribute('value', "");
            // })
            // jQuery('.js-signature').on('jq.signature.changed', function () {
            //     // Display the signature on the Agreement form and set the hidden input value.
            //     createListingSignaturePDF.innerHTML = "";
            //     let dataUrl = (jQuery('.js-signature') as any).jqSignature('getDataURL');
            //     let img = document.createElement('img');
            //     img.setAttribute('src', dataUrl);
            //     createListingSignaturePDF.append(img);
            //     createListingSignature.setAttribute('value', dataUrl);
            // });
        // } else {
            // // Below script runs at Edit property page
            // let amount = createListingPropPrice.value;
            // createListingPropPriceChinese.value = converter.toWords(amount);
            // createListingPropPrice.addEventListener('keyup', e => {
            //     e.preventDefault();
            //     let amount = createListingPropPrice.value;
            //     createListingPropPriceChinese.value = converter.toWords(amount);
            // })
        // }
    }
}

/*--------------------------------------------------------------------------
*  Edit Listing - show specific part of form with menu
* -------------------------------------------------------------------------*/
export function handleCreateListingEditMenu():void {
    // Desktop version
    const editPropertyMenu = document.querySelector('.menu-edit-property-wrap') as HTMLElement;
    if (editPropertyMenu) {
        const editPropertyMenuContactDetails = document.querySelector('#edit-property-menu-contact-details') as HTMLElement;
        const createListingAgreement = document.querySelector('#create-listing-agreement') as HTMLElement;
        if (editPropertyMenuContactDetails) {
            editPropertyMenuContactDetails.addEventListener('click', e => {
                e.preventDefault();
                createListingAgreement.setAttribute("style", "block");
            })
        }
    }
    
    // Mobile version
    // const editPropertyMenuMobile = document.querySelector('.dashboard-mobile-edit-menu-wrap') as HTMLElement;
    // if (editPropertyMenuMobile)  {
    //     // const editPropertyMenuContactDetailsMobile = editPropertyMenuMobile.querySelector('#bs-select-1-3') as HTMLElement;
    //     const createListingAgreement = document.querySelector('#create-listing-agreement') as HTMLElement;
        
    //     // jQuery('#menu_edit_mobile').on('change', function (e) {
    //     //     const editPropertyMenuContactDetailsMobile = editPropertyMenuMobile.querySelector('#bs-select-1-3') as HTMLElement;
    //     //     editPropertyMenuContactDetailsMobile.addEventListener('click', e => {
    //     //         e.preventDefault();
    //     //         console.log(createListingAgreement);
    //     //         createListingAgreement.setAttribute("style", "block");
    //     //     })
    //     // })
    //     jQuery('#menu_edit_mobile').on('click', function (e) {
    //         console.log('C');
    //     }
    // };

}

/*--------------------------------------------------------------------------
*  Create Listing - handle id card upload button
* -------------------------------------------------------------------------*/
export function handleCreatListingIDCardUpload() {
    // Click upload button to trigger the upload field
	const user_id_copy_button = document.querySelector('#create_listing_id_copy_button') as HTMLElement;
	const user_id_copy_label = document.querySelector('label[for="create_listing_id_copy"]') as HTMLElement;
    const user_id_copy_virtual_input_field = document.querySelector('.virtual-input-field') as HTMLElement;
    const user_id_copy_input_field = document.querySelector('#create_listing_id_copy') as HTMLInputElement;
    const next_button = document.querySelector('.btn-next') as HTMLButtonElement;
	if (document.querySelector('#description-price')) {	
		user_id_copy_button.addEventListener('click', e => {
			e.preventDefault();
			user_id_copy_label.click();
		});
        user_id_copy_virtual_input_field.addEventListener('click', e => {
			e.preventDefault();
			user_id_copy_label.click();
		});
        user_id_copy_input_field.addEventListener('change', e => {
            let filePath = user_id_copy_input_field.value;
            let fileName = filePath.replace(/^.*[\\\/]/, '');
            if(fileName) {
                user_id_copy_virtual_input_field.innerText = fileName;
                user_id_copy_virtual_input_field.style.borderColor = '#ced4da';
                user_id_copy_virtual_input_field.classList.remove('form-control', 'is-invalid');
            } else {
                user_id_copy_virtual_input_field.innerText = "請上載香港身份證副本";
            }
        })
        if (next_button) {
            next_button.addEventListener('click', e => {
                let fileName = user_id_copy_input_field.value;
                let indexDot = fileName.lastIndexOf('.') + 1;
                let extFile = fileName.substr(indexDot, fileName.length).toLowerCase();
                let correctFormat = false;
                if (extFile=="jpg" || extFile=="jpeg" || extFile=="png") {
                    correctFormat = true;
                }
                if (user_id_copy_input_field.value == '' || !correctFormat) {
                    e.preventDefault;
                    user_id_copy_virtual_input_field.classList.add('form-control', 'is-invalid');
                    user_id_copy_virtual_input_field.style.borderColor = '#dc3545';
                }
            });
        }
    }
}